import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import { Pencil } from 'lucide-react';
import { useShallow } from 'zustand/react/shallow';
import LangEnum from '../../../../../lang/LangEnum';
import useOrderBookStore from '../../../../../stores/OrderBook/orderBook.store';
import { OrderProductsTestIds } from '../../../../../utils/testIds/OrderProducts.testIds';
import { useApplicationContext } from '../../../../context/ApplicationContext/ApplicationContext';
import { useTranslation } from '../../../../translation/TranslationContext';
import useCanEditSuggestedOrder from '../../../hooks/useCanEditSuggestedOrder';
import { Order } from '../../../order.types';

interface EditSuggestedOrderButtonProps {
  order: Order;
}

const EditSuggestedOrderButton = ({ order }: EditSuggestedOrderButtonProps) => {
  const { translate } = useTranslation();
  const { team } = useApplicationContext();
  const handleChangeSelectedOrder = useOrderBookStore(
    useShallow((state) => state.handleChangeSelectedOrder),
  );
  const canEditSuggestedOrder = useCanEditSuggestedOrder();

  if (!canEditSuggestedOrder) {
    return null;
  }

  const handleClick = () => handleChangeSelectedOrder({ order, teamId: team?.id, translate });

  return (
    <Button
      variant="contained"
      color="secondary"
      size="medium"
      startIcon={<Icon icon={Pencil} size="sm" />}
      testId={OrderProductsTestIds.EDIT_SUGGESTED_ORDER_BUTTON}
      onClick={handleClick}
    >
      {translate(LangEnum.GLOBAL_EDIT)}
    </Button>
  );
};

export default EditSuggestedOrderButton;
